import { FC } from 'react';
import { RecurringAuth } from 'components/RecurringAuth';

export const RecurringAuthPage: FC = () => {
	return <RecurringAuth />;
};
